<template>
  <div>
    <!-- layout used for desktops -->
    <div v-if="layout === 'cards'" class="review--cards row mt-5">
      <div class="col-12" v-if="hasSlotTitle">
        <slot name="title" :country="$t('country.' + this.countryCode)" />
      </div>

      <div v-for="(review, id) of reviews.slice(0, 3)" :key="'review' + id" :class="[`col-${cardViewColsPerItem}`]">
        <template v-if="modernCard">
          <div class="card-border-color bg-white d-flex flex-column border rounded my-1 py-3 pl-3 pr-2">
            <div class="d-flex justify-content-between w-100">
              <div class="d-flex align-items-center">
                <img class="lazy rounded-circle mr-3" :data-src="review.image" width="32" height="32" alt="" />
                <span class="font-weight-bold fz-14">{{ review.name }}</span>
                <div class="ml-4 text-success d-flex align-items-center">
                  <img class="lazy mb-1 mr-1" :data-src="$root.cdn_url + '/assets/images/zmc10/check.svg'" />
                  <span class="fz-14 line-1">{{ $t("fmc5.reviews.verified") }}</span>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <div class="d-flex align-items-baseline bold fz-14 mr-2">
                  <img :src="$root.cdn_url + '/assets/images/location.svg'" class="mr-1" alt="" />
                  <span class="line-1">{{ reviewCity(id) }}</span>
                </div>
                <img class="lazy" :data-src="$root.cdn_url + '/assets/images/zmc10/5star.svg'" width="64" />
              </div>
            </div>
            <div class="mt-3 fz-14">"{{ review.text }}"</div>
          </div>
        </template>
        <template v-else>
          <div class="card">
            <div class="d-flex flex-wrap flex-lg-nowrap justify-content-between">
              <div class="review--cards__avatar mr-2">
                <img class="lazy" :data-src="review.image" width="54" height="54" alt="" />
              </div>
              <div class="review--cards__name">
                {{ review.name }}
                <div class="review--cards__verified">
                  <img class="lazy" :data-src="$root.cdn_url + '/assets/images/zmc10/check.svg'" />
                  {{ $t("fmc5.reviews.verified") }}
                </div>
              </div>
              <div class="review-5star text-lg-right">
                <img class="lazy" :data-src="$root.cdn_url + '/assets/images/zmc10/5star.svg'" width="64" />
              </div>
            </div>
            <div class="mt-2 review--cards__text">"{{ review.text }}"</div>
            <div class="review--cards__location mt-2">
              <img :src="$root.cdn_url + '/assets/images/location.svg'" class="mr-1" alt="" />
              {{ reviewCity(id) }}
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- Simplier layout for mobile -->
    <div v-else>
      <div v-for="(review, id) of reviews.slice(0, 3)" :key="'review' + id" class="review d-flex mt-3">
        <div>
          <div class="review__avatar">
            <img class="lazy" :data-src="review.image" width="54" height="54" alt="" />
          </div>
          <div class="review-5star">
            <img class="lazy" :data-src="$root.cdn_url + '/assets/images/zmc10/5star.svg'" />
          </div>
        </div>
        <div class="pl-3 w-100">
          <div class="review__header d-flex justify-content-between">
            <div class="review__verified">
              <img class="lazy mr-2" :data-src="$root.cdn_url + '/assets/images/zmc10/check.svg'" />
              {{ $t("fmc5.reviews.verified") }}
            </div>
            <div class="text-align-right">
              {{ review.name }} /
              {{ reviewCity(id) }}
            </div>
          </div>
          <div class="mt-2 review__text">"{{ review.text }}"</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Reviews",
  props: {
    reviews: {},
    layout: {},
    cardViewColsPerItem: {
      type: Number,
      required: false,
      default: 4
    },
    modernCard: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  inject: ["countryCode"],
  computed: {
    hasSlotTitle() {
      return this.$slots.title !== null;
    }
  },
  methods: {
    reviewCity(id) {
      return js_data.recently_bought_cities && js_data.recently_bought_cities[id] ? js_data.recently_bought_cities[id] : "";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";

.card-border-color {
  border-color: #dddddd;
}

.fz-14 {
  font-size: 14px;
}

.line-1 {
  line-height: 1;
}

.review {
  flex-direction: row;
  padding: 0;
  border-top: 0;
  font-family: Roboto, Arial, Helvetica, sans-serif;

  &__header {
    font-size: 14px;
  }

  &__avatar {
    height: 64px;
    overflow: hidden;

    & > img {
      width: 93px;
      border-radius: 50%;
      margin-top: -15px;
      padding: 3px;
      border: 1px solid rgb(181, 181, 181);
    }
  }

  &__verified {
    color: #16a085;
  }

  &__text {
    font-size: 16px;
  }

  &--cards {
    .card {
      padding: 30px 16px;
      background: #ffffff;
      border: 1px solid #dddddd;
      border-radius: 3px;
    }

    &__avatar {
      img {
        border-radius: 50%;
      }
    }

    &__verified {
      font-size: 14px;
      color: #4bad00;
      white-space: nowrap;
    }

    &__name {
      font-size: 18px;
      font-weight: 500;
    }

    &__text {
      font-weight: normal;
      font-size: 16px;
      line-height: 30px;
    }

    &__location {
      font-weight: 600;
      font-size: 14px;
    }
  }
}

@media screen and ($s-down) {
  .review__avatar {
    height: auto;

    & > img {
      width: 64px;
      border-radius: 0;
      margin-top: 0;
      border: 0;
    }
  }

  .review-5star {
    width: 64px;
  }
}
</style>
